<template>
  <div>
    <v-dialog
      scrollable
      :fullscreen="this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs"
      v-model="dialog"
      max-width="900"
    >
      <newDemandWizard v-bind:dialog.sync="dialog" />
    </v-dialog>

    <integratedSearchBar
      :button_display="currentUserCan('create', 'demand')"
      button_type="function"
      :button_function="button_function"
      button_label="Add a new demand"
      :dialog.sync="dialog"
      v-bind:search.sync="search"
      search_label="Search demands..."
    />

    <v-data-table
      :headers="headers"
      :items="demands"
      :search="search"
      :pagination.sync="pagination"
      :loading="loading"
      :expand="expand"
      flat
      rows-per-page-text="Demands per page"
    >
      <v-progress-linear
        slot="progress"
        color="blue"
        indeterminate
      ></v-progress-linear>
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
          <td>{{ props.item.created_at }}</td>
          <td>{{ props.item.company.name }}</td>
          <td v-if="!props.item.product_packagings_entities.length">
            No product
          </td>
          <td v-else>
            {{
              props.item.product_packagings_entities.length +
              " product" +
              (props.item.product_packagings_entities.length > 1 ? "s" : "")
            }}
            <v-icon small class="pl-2">keyboard_arrow_down</v-icon>
          </td>
          <!-- <td>{{ props.item.product_packagings_entities.length+' product'+ props.item.product_packagings_entities.length>1 ? "s" :""}}<v-icon small class="pl-2">keyboard_arrow_down</v-icon>  </td> -->
          <td>{{ props.item.port && props.item.port.name }}</td>

          <td class="px-0">
            <v-layout row align-center justify-center>
              <div>
                <v-switch
                  v-if="!props.item.salesforce_sync"
                  @change="updateSalesforceSync(props.item.id)"
                  :input-value="props.item.salesforce_sync"
                  style="height: 24px;"
                  flat
                />
                <!-- <v-btn 
                flat
                small
                color="#00a2e1"
                  v-if="!props.item.salesforce_sync"
                  @change="updateSalesforceSync(props.item.id)"
                  :input-value="props.item.salesforce_sync"
                  >
                  <v-img alt="Salesforce" :src="require('../../../public/public_images/salesforce_logo.png')" width="19" height="14" contain aspect-ratio="1"></v-img> <span class="pl-2">offline</span>
                </v-btn> -->

                <v-img
                  v-else
                  alt="Salesforce"
                  :src="
                    require('../../../public/public_images/salesforce_logo.png')
                  "
                  width="41"
                  height="29"
                  contain
                  aspect-ratio="1"
                ></v-img>

                <!-- <div style="color: green;" v-else>
                  <v-icon style="color: green">check</v-icon>salesforce
                </div> -->
              </div>
            </v-layout>
          </td>
          <td class="px-0">
            <v-layout row align-center justify-center>
              <destroyModale
                resourceName="demand"
                :itemId="props.item.id"
                warningText="You are going to remove this demand permanently"
                small
              />
            </v-layout>
          </td>
        </tr>
      </template>

      <template v-slot:expand="props">
        <v-card flat>
          <v-card-text class="pa-0">
            <v-data-table
              :headers="product_headers"
              :items="props.item.product_packagings_entities"
              hide-actions
              hide-headers
              flat
            >
              <template slot="items" slot-scope="products_props" class="px-2">
                <td>
                  <v-icon small class="pr-2" color="grey lighten1"
                    >shopping_cart</v-icon
                  >
                  {{ products_props.item.product.name }}
                </td>

                <td>
                  <template
                    v-for="(pr, index) in products_props.item.packagings"
                  >
                    <span :key="index" class="caption">
                      <br v-if="index > 0" />
                      <v-icon small class="pr-2" color="grey lighten1"
                        >mdi-package-variant</v-icon
                      >
                      {{ pr.name }}
                    </span>
                  </template>
                </td>
              </template>
              <template v-slot:no-data
                >Sorry, there is no product to display here.</template
              >
            </v-data-table>
          </v-card-text>
        </v-card>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DEMANDS_INDEX from "../../graphql/demands/index.gql";
import DEMANDS_UPDATE from "../../graphql/demands/update.gql";
import integratedSearchBar from "../shared/integratedSearchBar";
import newDemandWizard from "./newDemandWizard";
// import salesforce_logo from '../../../public/public_images/salesforce_logo.png';
export default {
  computed: {
    ...mapGetters("companyStore", ["demands"]),
  },
  components: { integratedSearchBar, newDemandWizard },
  data() {
    return {
      // salesforce_logo,
      dialog: false,
      loading: false,
      expand: false,
      pagination: {
        descending: true,
        rowsPerPage: 25,
        sortBy: "created_at",
      },
      search: "",
      product_headers: [
        {
          text: "Product",
          align: "left",
          sortable: true,
          value: "product.name",
        },
        {
          text: "Packagings",
          align: "left",
          sortable: true,
          value: "product.packaging.name",
        },
      ],
      headers: [
        {
          text: "Created At",
          align: "left",
          sortable: true,
          value: "created_at",
        },
        {
          text: "Supplier",
          align: "left",
          sortable: true,
          value: "search",
          width: "25%",
        },
        {
          text: "Products",
          align: "left",
          sortable: true,
          value: "product.name",
          width: "15%",
        },
        {
          text: "Port",
          align: "left",
          sortable: true,
          value: "port.name",
          width: "20%",
        },
        {
          text: "Salesforce Sync",
          align: "center",
          sortable: true,
          value: "salesforce_sync",
          width: "10%",
        },
        {
          text: "Actions",
          align: "center",
          sortable: false,
          width: "10%",
        },
      ],
    };
  },
  created() {
    this.subscribe(DEMANDS_INDEX, null, "companyStore", "demands");
  },
  beforeDestroy() {
    this.unsubscribe("demands");
  },
  methods: {
    button_function() {
      this.dialog = true;
    },
    updateSalesforceSync(id) {
      const demand = this.demands.filter((d) => d.id === id)[0];
      const message = demand.salesforce_sync ? "desync" : "sync";
      const demandAttributes = {
        name: demand.name,
        salesforce_sync: !demand.salesforce_sync,
      };
      this.sendMutation(
        message + " with salesforce.",
        "demand " + demand.name + " ",
        DEMANDS_UPDATE,
        { id: id, ...demandAttributes }
      );
    },
  },
};
</script>
<style lang="stylus">
div.v-table__overflow > table > tbody > tr > td.center > div > div {
  margin-top: 16px !important;
}
</style>
